import axios from 'axios';
import {useCookies} from "vue3-cookies";
const {cookies} = useCookies();

// const skiPassApiBaseURL = 'https://ski-pass.polyanaski.ru';
const skiPassApiBaseURL = 'https://svod.polyanaski.ru/ski-pass';
// const skiPassApiBaseURL = 'http://10.25.3.144';

console.log('cookies.get(\'xaccountuid\')', cookies.get('xaccountuid'))
const skiPassApi = axios.create({
    baseURL: skiPassApiBaseURL,
    headers: {
        'mrktsid': cookies.get('server_sid') || "",
        // 'd_tk': cookies.get('testMode') ? (crypto ? crypto.randomUUID() : '') : null,
        'd_tk': cookies.get('testMode') ? 'c63d5e3f-f3db-4aac-be71-20af9e72fc4c' : null,
        'xaccountuid': cookies.get('xaccountuid') || "",
    }
});

export {skiPassApiBaseURL, skiPassApi};